"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  /**
   * 元素绑定事件
   * @param {object}   el        目标元素
   * @param {string}   type      事件类型
   * @param {function} callback  处理函数
   */
  on: function on(el, type, callback) {
    if (el.addEventListener) {
      el.addEventListener(type, callback);
    } else {
      el.attachEvent("on ".concat(type), function () {
        callback.call(el);
      });
    }
  },

  /**
   * 元素删除事件
   * @param {object}   el        目标元素
   * @param {string}   type      事件类型
   * @param {function} callback  处理函数
   */
  off: function off(el, type, callback) {
    if (el.removeEventListener) {
      el.removeEventListener(type, callback);
    } else {
      el.detachEvent("off ".concat(type), callback);
    }
  },
  once: function once(el, type, callback) {
    var typeArray = type.split(' ');

    var recursiveFunction = function recursiveFunction(e) {
      e.target.removeEventListener(e.type, recursiveFunction);
      return callback(e);
    };

    for (var i = typeArray.length - 1; i >= 0; i -= 1) {
      this.on(el, typeArray[i], recursiveFunction);
    }
  }
};
exports.default = _default;